<template>
  <b-form @submit.prevent="$emit('processProveedor', proveedor)">
    <!-- Proveedor Info: Input Fields -->
    <b-form>
      <b-row>

        <!-- Field: Rut -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Rut"
            label-for="rut"
          >
            <b-form-input
              id="rut"
              v-model="proveedor.rut"
              :state="!$v.proveedor.rut.$invalid"
              placeholder="Introduce el rut"
              @input="$v.proveedor.$touch"
            />
            <b-form-invalid-feedback
              v-if="$v.proveedor.$dirty"
              id="rutInfo"
            >
              El campo rut
              <span v-if="!$v.proveedor.rut.required"> es requerido.</span>
              <span v-if="!$v.proveedor.rut.maxLength"> debe tener max 50 caracteres.</span>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <!-- Field: Nombre -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Nombre"
            label-for="nombre"
          >
            <b-form-input
              id="nombre"
              v-model="proveedor.nombre"
              :state="!$v.proveedor.nombre.$invalid"
              placeholder="Introduce el nombre"
              @input="$v.proveedor.$touch"
            />
            <b-form-invalid-feedback
              v-if="$v.proveedor.$dirty"
              id="nombreInfo"
            >
              El campo nombre
              <span v-if="!$v.proveedor.nombre.required"> es requerido.</span>
              <span v-if="!$v.proveedor.nombre.maxLength"> debe tener max 80 caracteres.</span>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <!-- Field: Razón Social -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Razón Social"
            label-for="razonSocial"
          >
            <b-form-input
              id="razonSocial"
              v-model="proveedor.razonSocial"
              :state="!$v.proveedor.razonSocial.$invalid"
              placeholder="Introduce la razón social"
              @input="$v.proveedor.$touch"
            />
            <b-form-invalid-feedback
              v-if="$v.proveedor.$dirty"
              id="razonSocialInfo"
            >
              El campo razón social
              <span v-if="!$v.proveedor.razonSocial.required"> es requerido.</span>
              <span v-if="!$v.proveedor.razonSocial.maxLength"> debe tener max 200 caracteres.</span>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <!-- Field: Nombre -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Giro"
            label-for="giro"
          >
            <b-form-input
              id="giro"
              v-model="proveedor.giro"
              :state="!$v.proveedor.giro.$invalid"
              placeholder="Introduce el giro"
              @input="$v.proveedor.$touch"
            />
            <b-form-invalid-feedback
              v-if="$v.proveedor.$dirty"
              id="giroInfo"
            >
              El campo giro
              <span v-if="!$v.proveedor.giro.required"> es requerido.</span>
              <span v-if="!$v.proveedor.giro.maxLength"> debe tener max 80 caracteres.</span>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <!-- Field: Telefono -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Teléfono"
            label-for="telefono"
          >
            <b-form-input
              id="telefono"
              v-model="telefono"
              :state="!$v.proveedor.telefono.$invalid"
              placeholder="Introduce el teléfono"
              @input="$v.proveedor.$touch"
              @keyup="formatearTelefono"
              @blur="formatearTelefono"
            />
            <b-form-invalid-feedback
              v-if="$v.proveedor.$dirty"
              id="telefonoInfo"
            >
              El campo teléfono
              <span v-if="!$v.proveedor.telefono.required"> es requerido.</span>
              <span v-if="!$v.proveedor.telefono.maxLength"> debe tener max 25 caracteres.</span>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <!-- Field: Correo -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Correo"
            label-for="correo"
          >
            <b-form-input
              id="correo"
              v-model="proveedor.correo"
              :state="!$v.proveedor.correo.$invalid"
              type="email"
              placeholder="Introduce el correo"
              @input="$v.proveedor.$touch"
            />
            <b-form-invalid-feedback
              v-if="$v.proveedor.$dirty"
              id="correoInfo"
            >
              El campo correo
              <span v-if="!$v.proveedor.correo.required"> es requerido.</span>
              <span v-if="!$v.proveedor.correo.maxLength"> debe tener max 80 caracteres.</span>
              <span v-if="!$v.proveedor.correo.email"> debe ser un correo valido.</span>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <!-- Field: Dirección -->
        <b-col
          cols="12"
          md="12"
        >
          <b-form-group
            label="Dirección"
            label-for="direccion"
          >
            <b-form-input
              id="direccion"
              v-model="proveedor.direccion"
              :state="!$v.proveedor.direccion.$invalid"
              placeholder="Introduce la dirección"
              @input="$v.proveedor.$touch"
            />
            <b-form-invalid-feedback
              v-if="$v.proveedor.$dirty"
              id="direccionInfo"
            >
              El campo dirección
              <span v-if="!$v.proveedor.direccion.required"> es requerido.</span>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

      </b-row>
    </b-form>

    <!-- Action Buttons -->
    <btnSubmit
      :btnDisabled="$v.proveedor.$invalid"
      :btnText="proveedorSubmit"
    />

  </b-form>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BFormInvalidFeedback,
} from 'bootstrap-vue'
import { validationMixin } from 'vuelidate'
import {
  required, maxLength, email,
} from 'vuelidate/lib/validators'
import { formatearTelefono } from '@/mixins/forms'

const btnSubmit = () => import('@/layouts/components/Recycled/Form/btnSubmit.vue')

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormInvalidFeedback,
    // vSelect,
    btnSubmit,
  },
  mixins: [validationMixin, formatearTelefono],
  props: {
    proveedor: {
      type: Object,
      required: true,
    },
    proveedorSubmit: {
      type: String, // Texto del boton
      default: 'Guardar Proveedor',
    },
  },
  data() {
    return {
      telefono: this.proveedor.telefono,
    }
  },
  watch: {
    telefono() {
      this.proveedor.telefono = this.telefono
    },
  },
  validations: {
    proveedor: {
      rut: {
        required,
        maxLength: maxLength(50),
      },
      direccion: {
        required,
      },
      razonSocial: {
        required,
        maxLength: maxLength(200),
      },
      nombre: {
        required,
        maxLength: maxLength(80),
      },
      giro: {
        required,
        maxLength: maxLength(80),
      },
      telefono: {
        required,
        maxLength: maxLength(25),
      },
      correo: {
        required,
        maxLength: maxLength(80),
        email,
      },
      estado: {},
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
